// Synchronous config loader for runtime environment variables
class ConfigLoader {
  constructor() {
    this.config = null;
    this.loaded = false;
  }

  async loadConfig() {
    if (this.loaded) return this.config;

    try {
      const response = await fetch('/env.json');
      const runtimeConfig = await response.json();
      
      this.config = {
        REACT_APP_API_ENDPOINT: runtimeConfig.REACT_APP_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT || '',
        REACT_APP_AWS_REGION: runtimeConfig.REACT_APP_AWS_REGION || process.env.REACT_APP_AWS_REGION || 'ap-south-1',
        REACT_APP_AD_TENANT_ID: runtimeConfig.REACT_APP_AD_TENANT_ID || process.env.REACT_APP_AD_TENANT_ID || 'd44ff723-4fa7-405e-afc0-43c21e573043',
        REACT_APP_AD_CLIENT_ID: runtimeConfig.REACT_APP_AD_CLIENT_ID || process.env.REACT_APP_AD_CLIENT_ID || '',
        REACT_APP_ENVIRONMENT: runtimeConfig.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT || 'dev',
        REACT_APP_URL: process.env.REACT_APP_URL || `${window.location.protocol}//${window.location.host}`
      };
      
      this.loaded = true;
    } catch (error) {
      console.warn('Could not load runtime config from env.json:', error);
      // Fallback to process.env
      this.config = {
        REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || '',
        REACT_APP_AWS_REGION: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
        REACT_APP_AD_TENANT_ID: process.env.REACT_APP_AD_TENANT_ID || 'd44ff723-4fa7-405e-afc0-43c21e573043',
        REACT_APP_AD_CLIENT_ID: process.env.REACT_APP_AD_CLIENT_ID || '',
        REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'dev',
        REACT_APP_URL: process.env.REACT_APP_URL || `${window.location.protocol}//${window.location.host}`
      };
      this.loaded = true;
    }
    
    return this.config;
  }

  getConfig() {
    return this.config;
  }
}

const configLoader = new ConfigLoader();
export default configLoader;
